import { Link } from 'react-router-dom';
import { LogOut, Moon, Sun, ShieldCheck, PanelLeft, PanelLeftClose, BookOpen } from 'lucide-react';
import { useAuth } from '@/shared/auth/AuthProvider';
import { useTheme } from '@/shared/theme/ThemeProvider';
import { Button } from '@/components/ui/Button';
import { OrgSwitcher } from './OrgSwitcher';

interface TopbarProps {
  sidebarCollapsed: boolean;
  onToggleSidebar: () => void;
}

export function Topbar({ sidebarCollapsed, onToggleSidebar }: TopbarProps) {
  const { user, logout } = useAuth();
  const { theme, toggle } = useTheme();

  return (
    <header className="flex h-14 shrink-0 items-center justify-between border-b border-neutral-200 bg-neutral-0 px-4 dark:border-neutral-700 dark:bg-neutral-800">
      <div className="flex items-center gap-2 text-brand-600 dark:text-brand-300">
        <Button
          size="sm"
          variant="ghost"
          aria-label={sidebarCollapsed ? 'Expandir menu lateral' : 'Recolher menu lateral'}
          onClick={onToggleSidebar}
          leadingIcon={sidebarCollapsed ? <PanelLeft size={16} /> : <PanelLeftClose size={16} />}
        />
        <ShieldCheck size={20} strokeWidth={2} />
        <span className="text-md font-semibold tracking-tight text-neutral-800 dark:text-neutral-100">ICTUS CME</span>
        {user?.org_name ? (
          <span className="ml-2 hidden text-xs text-neutral-500 md:inline">· {user.org_name}</span>
        ) : null}
      </div>
      <div className="flex items-center gap-2">
        <OrgSwitcher />
        <Link
          to="/ajuda"
          className="ict-focus-ring inline-flex h-8 items-center gap-1 rounded border border-neutral-300 px-2 text-xs text-neutral-700 hover:bg-neutral-100 dark:border-neutral-700 dark:text-neutral-200 dark:hover:bg-neutral-700"
        >
          <BookOpen size={14} />
          Ajuda
        </Link>
        {user ? (
          <div className="hidden flex-col items-end leading-tight md:flex">
            <span className="text-xs font-medium text-neutral-800 dark:text-neutral-100">{user.full_name}</span>
            <span className="text-xxs uppercase tracking-wider text-neutral-500">{user.role}</span>
          </div>
        ) : null}
        <Button
          size="sm"
          variant="ghost"
          aria-label={theme === 'dark' ? 'Tema claro' : 'Tema escuro'}
          onClick={toggle}
          leadingIcon={theme === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
        >
          {theme === 'dark' ? 'Claro' : 'Escuro'}
        </Button>
        {user ? (
          <Button size="sm" variant="secondary" onClick={logout} leadingIcon={<LogOut size={16} />}>
            Sair
          </Button>
        ) : null}
      </div>
    </header>
  );
}
